<script>
    import { fly } from "svelte/transition";
    import { Textarea,Toast,notify } from "../index";

    function handleEvent(type){
        notify.show(`触发事件：${type}`)
    }
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Textarea  placeholder='请输入内容'/>
    </div>
    <h4 class="example-title">指定行数</h4>
    <div class="example-body">
        <Textarea rows={5} placeholder='请输入内容'/>
    </div>
    <h4 class="example-title">根据内容自动调整高度</h4>
    <div class="example-body">
        <Textarea autoSize placeholder='请输入内容'/>
    </div>
    
    <h4 class="example-title">字数统计</h4>
    <div class="example-body">
        <Textarea showCount defaultValue="永远相信美好的事情即将发生" rows={3} placeholder='请输入内容'/>
    </div>
    <h4 class="example-title">字数限制</h4>
    <div class="example-body">
        <Textarea showCount defaultValue="永远相信美好的事情即将发生" maxLength={30} rows={3} placeholder='请输入内容'/>
    </div>
    <h4 class="example-title">禁用状态</h4>
    <div class="example-body">
        <Textarea defaultValue="永远相信美好的事情即将发生" disabled placeholder='请输入内容'/>
    </div>
    <h4 class="example-title">只读状态</h4>
    <div class="example-body">
        <Textarea defaultValue="永远相信美好的事情即将发生" readonly placeholder='请输入内容'/>
    </div>

    <h4 class="example-title">事件</h4>
    <div class="example-body">
        <Textarea defaultValue="永远相信美好的事情即将发生" on:blur={()=>handleEvent('blur')} on:change={(e)=>console.log(e.detail)} on:focus={()=>handleEvent('focus')} placeholder='请输入内容'/>
    </div>

</div>
<Toast/>
<style lang="less">
    @import "./example.less";
</style>
